import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import { FolderSection, LabelValue } from '../Elements';
import { useVehicle } from '../../../hooks/useCalendar/useRecordBlocs/useVehicle';
import { t } from '../../common/Translate';
import { AlertModalHistovec } from '../../common/Modal/AlertModalHistovec';
import VinDecodingEquipmentsModal from '../../common/equipment/VinDecodingEquipmentsModal';

export const VehicleBloc = ({ recordId }) => {
  const {
    vehicleTitle,
    labels,
    versionName,
    goToVehIdentify,
    active,
    alert,
    alertMessage,
    countryId,
    toggleHistovecInfo,
    handleCancel,
    isOpen,
    body,
    status,
    histovecStatus,
    histovecAlerts,
    privateOwner,
    setHistoryChanges,
    companyOwner,
    retriveHistovecInfo,
    ownerMode,
    setOwnerMode,
    handleKeyPress,
    roleIsViewer,
    carEquipment,
    setIsOpenEquipments,
    isOpenEquipments,
    isNrmFile,
  } = useVehicle(recordId);

  return (
    <>
      <FolderSection dataTestid="vehicle-bloc" action={goToVehIdentify} showArrow={active} showVehInfos>
        <>
          {alert && (
            <p className="text-danger">
              <FontAwesomeIcon icon={faBell} className="mr-2" />
              {alertMessage}
            </p>
          )}
          <p className="calendar-meeting-folder-section-title active">{vehicleTitle}</p>
          <span className="label">{versionName}</span>
          {labels.map(({ label, value }) => (
            <LabelValue label={label} value={value} key={label} />
          ))}
          {countryId === 1 && !roleIsViewer && (
            <>
              {status && status === 'pending' && (
                <>
                  <LabelValue label={t('titleHistovec')} value={t('histovecRequestOngoing')} />
                  <button
                    type="button"
                    className={`btn btn-3 seeHistovecInfo histovac-info-${status}`}
                    onClick={toggleHistovecInfo}
                  >
                    {t('histovecRequestOngoing')}
                  </button>
                </>
              )}
              {!status && (
                <button type="button" className="btn btn-3 seeHistovecInfo" onClick={toggleHistovecInfo}>
                  {t('requestHistovecButton')}
                </button>
              )}
              {status && status === 'success' && (
                <>
                  <button
                    type="button"
                    className={`btn btn-3 seeHistovecInfo histovac-info-${status}`}
                    onClick={toggleHistovecInfo}
                  >
                    {t('seeHistovecInfo')}
                  </button>
                </>
              )}
              {status && status === 'failed' && (
                <>
                  <LabelValue label={t('titleHistovec')} value={t('histovecReportError')} />
                  <button
                    type="button"
                    className={`btn btn-3 seeHistovecInfo histovac-info-${status}`}
                    onClick={toggleHistovecInfo}
                  >
                    {t('HistovecNotAvailable')}
                  </button>
                </>
              )}
            </>
          )}
          {!!carEquipment?.length && !isNrmFile && (
            <div>
              <button
                type="button"
                className="btn btn-3 mt-4 seeHistovecInfo"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpenEquipments(true);
                }}
              >
                {t('seeEquipement')}
              </button>
            </div>
          )}
        </>
      </FolderSection>
      {!!carEquipment?.length && !isNrmFile && (
        <VinDecodingEquipmentsModal
          isOpen={isOpenEquipments}
          setIsOpen={setIsOpenEquipments}
          equipments={carEquipment || []}
        />
      )}
      <AlertModalHistovec
        isOpen={isOpen}
        toggle={toggleHistovecInfo}
        body={body}
        handleCancel={handleCancel}
        size={status && status === 'success' ? 'lg' : 'md'}
        histovecStatus={histovecStatus}
        histovecAlerts={histovecAlerts}
        privateOwner={privateOwner}
        retriveHistovecInfo={retriveHistovecInfo}
        companyOwner={companyOwner}
        setHistoryChanges={setHistoryChanges}
        ownerMode={ownerMode}
        setOwnerMode={setOwnerMode}
        handleKeyPress={handleKeyPress}
      />
    </>
  );
};

VehicleBloc.propTypes = {
  recordId: PropTypes.number.isRequired,
};
